import { render, staticRenderFns } from "./ImmediateCompensationDetailModal.vue?vue&type=template&id=05b5bf47&scoped=true"
import script from "./ImmediateCompensationDetailModal.vue?vue&type=script&lang=ts"
export * from "./ImmediateCompensationDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./ImmediateCompensationDetailModal.vue?vue&type=style&index=0&id=05b5bf47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b5bf47",
  null
  
)

export default component.exports